import { PostReportReason } from '@/lib/constants/post';
import axiosInstance from '../axios/axiosInstance';
import { fetcher } from './fetcher';

export const createPost = async (fileName: string) => {
  try {
    const postResponse = await axiosInstance.post(`/post`, {
      fileName: fileName
    });
    return { postResponse, error: null };
  } catch (error) {
    console.log(error);
    return { postResponse: null, error };
  }
};

export const createGif = async (fileName: string) => {
  try {
    const postResponse = await axiosInstance.post(`/post/gif`, {
      fileName: fileName
    });
    return { postResponse, error: null };
  } catch (error) {
    console.log(error);
    return { postResponse: null, error };
  }
};

export const reportPost = async (
  postId: string,
  reason: PostReportReason,
  message: string,
  otherReason?: string
) => {
  try {
    const postResponse = await axiosInstance.post(`/post/${postId}/report`, {
      reason,
      message,
      otherReason
    });
    return { postResponse, error: null };
  } catch (error) {
    console.log(error);
    return { postResponse: null, error };
  }
};

export const likePost = async (postId: string) => {
  if (!postId) {
    return;
  }
  try {
    const likeResponse = await axiosInstance.post(`/post/${postId}/like`, {});
    // console.log(likeResponse);
    return { likeResponse, error: null };
  } catch (error) {
    console.log(error);
    return { likeResponse: null, error };
  }
};

export const unlikePost = async (postId: string) => {
  if (!postId) {
    return;
  }
  try {
    const unlikeResponse = await axiosInstance.post(`/post/${postId}/unlike`, {});
    return { unlikeResponse, error: null };
  } catch (error) {
    console.log(error);
    return { unlikeResponse: null, error };
  }
};

export const getPost = async (postId: string) => {
  try {
    const postDetailsResponse = await axiosInstance.get(`/post/${postId}`);

    // const cacheDuration = 15 * 24 * 60 * 60;
    // postDetailsResponse.headers['Cache-Control'] = `s-maxage=${cacheDuration}, stale-while-revalidate`;

    // console.log(postDetailsResponse);

    return { postDetailsResponse, error: null };
  } catch (error) {
    console.log(error);
    return { postDetailsResponse: null, error };
  }
};

export const hidePost = async (postId: string) => {
  try {
    const hideResponse = await axiosInstance.post(`/post/${postId}/hide`, {});
    return { hideResponse, error: null };
  } catch (error) {
    console.log(error);
    return { hideResponse: null, error };
  }
};

// Note: getHotFeed and getUserLikes removed since source selection is now handled via post page redirects only

export const getPostPaginationCache = async () => {
  try {
    const paginationCacheResponse = await axiosInstance.get(`/post/cache/pagination`);
    // console.log(paginationCacheResponse);
    return { paginationCacheResponse, error: null };
  } catch (error) {
    console.log(error);
    return { paginationCacheResponse: null, error };
  }
};

export const getPostPageCount = async () => {
  try {
    const pageCountResponse = await axiosInstance.get(`/post/page/count`);
    return { pageCountResponse, error: null };
  } catch (error) {
    console.log(error);
    return { pageCountResponse: null, error };
  }
};

export const getPostByPage = async (pageNumber: number) => {
  try {
    const pagePostsResponse = await axiosInstance.get(`/post/page/${pageNumber}`);
    return { pagePostsResponse, error: null };
  } catch (error) {
    console.log(error);
    return { pagePostsResponse: null, error };
  }
};

export const getPostsByTagIds = async (
  tagIds: string[],
  limit: number = 20,
  timespan: number = 0,
  images: number = 1,
  views: number = 1,
  likes: number = 1,
  author: number = 1,
  generator: number = 1,
  generatorId: string
) => {
  try {
    const tagIdsString = tagIds.join(',');
    const params = {
      limit: limit.toString(),
      timespan: timespan.toString(),
      tagId: tagIdsString,
      images: images.toString(),
      views: views.toString(),
      likes: likes.toString(),
      author: author.toString(),
      generator: generator.toString(),
      generatorId
    };

    const config = {
      params: params
    };

    const response = await axiosInstance.get(`/post/collection`, config);

    // console.log(response)
    return { response, error: null };
  } catch (error) {
    console.log(error);
    return { response: null, error };
  }
};

export const getRelatedPosts = async (postId: string) => {
  try {
    const relatedPostsResponse = await axiosInstance.get(`/post/related/${postId}`);

    // const cacheDuration = 15 * 24 * 60 * 60;
    // relatedPostsResponse.headers[
    //   "Cache-Control"
    // ] = `s-maxage=${cacheDuration}, stale-while-revalidate`;

    return { relatedPostsResponse, error: null };
  } catch (error) {
    return { relatedPostsResponse: null, error };
  }
};

export const getPostTags = async (postId: string, style: string, tagType: string) => {
  try {
    const postTagsResponse = await axiosInstance.get(
      `/post/tags/${postId}?style=${style}&type=${tagType}`
    );
    return { postTagsResponse, error: null };
  } catch (error) {
    // console.log(error);
    return { postTagsResponse: null, error };
  }
};

export const getUserProfileGifs = async (
  userId: string,
  sort: 'new' | 'top' = 'new',
  cursor?: string
) => {
  try {
    let url = `${process.env.NEXT_PUBLIC_BACKEND_URL}/post/profile-gifs?user=${userId}&sort=${sort}&include=userLikes`;
    if (cursor) {
      url += `&cursor=${cursor}`;
    }
    return await fetcher(url);
  } catch (error) {
    console.error('Error fetching user profile GIFs:', error);
    throw error;
  }
};

export const getPostUpscales = async (postId: string) => {
  try {
    const postUpscalesResponse = await axiosInstance.get(`/upscale/${postId}`);
    return { postUpscalesResponse, error: null };
  } catch (error) {
    return { postUpscalesResponse: null, error };
  }
};

export const checkReviewStatus = async (postId: string) => {
  try {
    const reviewStatusUrl = `${process.env.NEXT_PUBLIC_BACKEND_URL}/post/review-status/${postId}`;

    const response = await fetch(reviewStatusUrl, {
      method: 'GET',
      headers: {
        'x-origin': process.env.NEXT_PUBLIC_BASE_URL || '',
        'X-SSR': process.env.SSR_HEADER || ''
      },
      next: {
        tags: [`review-${postId}`],
        revalidate: 300 // 5 minutes
      }
    });

    if (!response.ok) {
      return { reviewStatus: null, error: response.status };
    }

    const data = await response.json();
    const reviewStatus = data?.reviewStatus || 'none';
    return { reviewStatus, error: null };
  } catch (error) {
    return { reviewStatus: null, error };
  }
};

export const fetchPostSSR = async (postId: string, localeKey: string) => {
  try {
    const url = `${process.env.NEXT_PUBLIC_BACKEND_URL}/post/ssr/${localeKey}/${postId}`;
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'x-origin': process.env.NEXT_PUBLIC_BASE_URL || '',
        'X-SSR': process.env.SSR_HEADER || ''
      },
      next: {
        tags: [`posts-${postId}`],
        revalidate: 3600 * 24 // 24 hours
      }
    });

    if (!response.ok) {
      return { postDetailsResponse: null, error: 'Failed to fetch post details' };
    }

    const postDetailsResponse = await response.json();
    return { postDetailsResponse, error: null };
  } catch (error) {
    return { postDetailsResponse: null, error };
  }
};
